import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

interface Props {
  touchWidth?: number;
  touchHeight?: number;
  onClick: (e: React.MouseEvent) => void;

  [key: string]: any;
}

export function TouchAccessibilityWrapper({
  touchWidth,
  touchHeight,
  children,
  onClick,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <Area {...rest}>
      {children}
      <TouchArea width={touchWidth} height={touchHeight} onClick={onClick} />
    </Area>
  );
}

const Area = styled.div`
  position: relative;

  svg {
    display: block;
  }
`;

const TouchArea = styled.div<{ width?: number; height?: number }>`
  position: absolute;
  width: ${({ width }) => (width ? `${width}px` : 'calc(100% + 12px)')};
  min-height: ${({ height }) => (height ? `${height}px` : 'calc(100% + 12px)')};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;
